import { render, staticRenderFns } from "./TabellaCicloStandard.vue?vue&type=template&id=87ca772c&scoped=true&"
import script from "./TabellaCicloStandard.vue?vue&type=script&lang=js&"
export * from "./TabellaCicloStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ca772c",
  null
  
)

export default component.exports